import React, { useState } from "react";
import "./PaintVis.css";

const rooms = {
  bedroom: [
    { main: "/assets/bedroom1.jpg", mask: "/assets/bedroom1-mask.png" },
    { main: "/assets/bedroom2.jpg", mask: "/assets/bedroom2-mask.png" },
    { main: "/assets/bedroom3.jpg", mask: "/assets/bedroom3-mask.png" },
    { main: "/assets/bedroom4.jpg", mask: "/assets/Bedroom4-mask.png" },
    { main: "/assets/bedroom5.jpg", mask: "/assets/bedroom5-mask.png" },
    { main: "/assets/bedroom6.jpg", mask: "/assets/bedroom6-mask.png" },
    { main: "/assets/bedroom7.jpg", mask: "/assets/bedroom7-mask.png" },
    { main: "/assets/bedroom8.jpg", mask: "/assets/bedroom8-mask.png" },
    { main: "/assets/bedroom9.jpg", mask: "/assets/bedroom9-mask.png" },
  ],
  "Drawing Room": [
    { main: "/assets/drawingroom1.jpg", mask: "/assets/drawingroom1-mask.png" },
    { main: "/assets/drawingroom2.jpg", mask: "/assets/drawingroom2-mask.png" },
    {
      main: "/assets/drawingroom3.jpeg",
      mask: "/assets/drawingroom3-mask.png",
    },
    { main: "/assets/drawingroom4.png", mask: "/assets/drawingroom4-mask.png" },
    { main: "/assets/drawingroom5.jpg", mask: "/assets/drawingroom5-mask.png" },
    { main: "/assets/drawingroom6.jpg", mask: "/assets/drawingroom6-mask.png" },
    { main: "/assets/drawingroom7.jpg", mask: "/assets/drawingroom7-mask.png" },
    { main: "/assets/drawingroom8.jpg", mask: "/assets/drawingroom8-mask.png" },
    { main: "/assets/drawingroom9.jpg", mask: "/assets/drawingroom9-mask.png" },
  ],
  "Dining Room": [
    { main: "/assets/diningroom1.jpg", mask: "/assets/diningroom1-mask.png" },
    { main: "/assets/diningroom2.jpg", mask: "/assets/diningroom2-mask.png" },
    { main: "/assets/diningroom3.jpg", mask: "/assets/diningroom3-mask.png" },
    { main: "/assets/diningroom4.jpg", mask: "/assets/diningroom4-mask.png" },
    { main: "/assets/diningroom5.jpg", mask: "/assets/diningroom5-mask.png" },
    { main: "/assets/diningroom6.jpg", mask: "/assets/diningroom6-mask.png" },
    { main: "/assets/diningroom7.jpg", mask: "/assets/diningroom7-mask.png" },
    { main: "/assets/diningroom8.jpg", mask: "/assets/diningroom8-mask.png" },
    { main: "/assets/diningroom9.jpg", mask: "/assets/diningroom9-mask.png" },
  ],
  kitchen: [
    { main: "/assets/kitchen1.jpg", mask: "/assets/kitchen1-mask.png" },
    { main: "/assets/kitchen2.jpg", mask: "/assets/kitchen2-mask.png" },
    { main: "/assets/kitchen3.jpg", mask: "/assets/kitchen3-mask.png" },
    { main: "/assets/kitchen4.jpg", mask: "/assets/kitchen4-mask.png" },
    { main: "/assets/kitchen5.jpg", mask: "/assets/kitchen5-mask.png" },
    { main: "/assets/kitchen6.jpg", mask: "/assets/kitchen6-mask.png" },
    { main: "/assets/kitchen7.jpg", mask: "/assets/kitchen7-mask.png" },
    { main: "/assets/kitchen8.jpg", mask: "/assets/kitchen8-mask.png" },
    { main: "/assets/kitchen9.jpg", mask: "/assets/kitchen9-mask.png" },
  ],
};

export default function PaintVis() {
  const [selectedRoom, setSelectedRoom] = useState("bedroom");
  const [selectedImage, setSelectedImage] = useState(rooms["bedroom"][0].main);
  const [selectedMask, setSelectedMask] = useState(rooms["bedroom"][0].mask);
  const [color, setColor] = useState("#ffffff"); 

  const filledImages = [
    ...rooms[selectedRoom],
    ...Array(9 - rooms[selectedRoom].length).fill(null),
  ];

  return (
    <div className="paintvis-wrapper">
      {/* --- Top Section --- */}
      <section className="paintvis-header">
        <h1>See Your Space In Color Before You Paint</h1>
        <p>
          Bring your vision to life before you paint. With our interactive paint
          visualizer, you can upload a photo of your room or explore sample
          spaces to see how different colors look in real time. Experiment
          freely, compare shades, and find the perfect color that matches your
          style — all before making a single brushstroke.
        </p>
      </section>

      {/* --- Visualizer Section --- */}
      <div className="paintvis-page">
        <div className="paintvis-container">
          {/* --- Select Room --- */}
          <div className="room-column">
            <h3>Select A Room</h3>
            <div className="room-radio-group">
              {Object.keys(rooms).map((room) => (
                <label key={room} className="radio-label">
                  <input
                    type="radio"
                    name="room"
                    checked={selectedRoom === room}
                    onChange={() => {
                      setSelectedRoom(room);
                      setSelectedImage("");
                      setSelectedMask("");
                      setColor("#ffffff"); 
                    }}
                  />
                  {room.charAt(0).toUpperCase() + room.slice(1)}
                </label>
              ))}
            </div>
          </div>

          {/* --- Select Image --- */}
          <div className="image-column">
            <h3>Select An Image</h3>
            <div className="image-grid">
              {filledImages.map((img, i) =>
                img ? (
                  <div
                    key={i}
                    className={`image-box ${
                      selectedImage === img.main ? "selected" : ""
                    }`}
                    onClick={() => {
                      setSelectedImage(img.main);
                      setSelectedMask(img.mask);
                      setColor("#ffffff"); 
                    }}
                  >
                    <img src={img.main} alt={`room-${i}`} />
                  </div>
                ) : (
                  <div key={i} className="image-box transparent-box-grid">
                    <div className="transparent-pattern"></div>
                  </div>
                )
              )}
            </div>
          </div>

          {/* --- Visualizer --- */}
          <div className="preview-column">
            <h3>Visualise Your Favourite Shades</h3>
            <p className="shade-subtitle">Select a Shade:</p>

            {selectedImage ? (
              <div className="preview-wrapper">
                <div className="room-preview">
                  <img
                    src={selectedImage}
                    alt="room"
                    className="room-main fade-smooth"
                  />
                  <div
                    className="room-color fade-smooth"
                    style={{ backgroundColor: color }}
                  ></div>
                  <img
                    src={selectedMask}
                    alt="mask"
                    className="room-mask fade-smooth"
                  />
                </div>

                <div className="color-tools">
                  <div className="color-pick">
                    <label>Pick your own:</label>
                    <input
                      type="color"
                      value={color}
                      onChange={(e) => setColor(e.target.value)}
                    />
                  </div>

                  <div className="transparent-box">
                    <label>Selected Color:</label>
                    <div
                      className="transparent-preview"
                      style={{
                        backgroundColor: color,
                        color: "#fff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "12px",
                        fontWeight: "500",
                        textTransform: "uppercase",
                      }}
                    >
                      {color}
                    </div>
                  </div>
                  {/* <button className="add-btn">Add This Shade To Cart</button> */}
                </div>
              </div>
            ) : (
              <p className="placeholder">Select an image to visualize</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
